import { render, staticRenderFns } from "./product-client-list.vue?vue&type=template&id=359044d2&scoped=true&"
import script from "./product-client-list.vue?vue&type=script&lang=js&"
export * from "./product-client-list.vue?vue&type=script&lang=js&"
import style0 from "./product-client-list.vue?vue&type=style&index=0&id=359044d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359044d2",
  null
  
)

export default component.exports